import axios from 'axios';

import { URLS } from '@/constants/urls';

export const fetch = axios.create({
  baseURL: URLS.API_URL,
  withCredentials: true,
});
